// extracted by mini-css-extract-plugin
export default {"form_container":"form_container---pg27h","remove_btn":"remove_btn---vaoNM","row_container":"row_container---xvpzB"};